export default {
    props: {
        messagesCommandsCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.cancel'
        }, 
        messagesCommandsCanceledit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.canceledit'
        }, 
        messagesCommandsCreate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.create'
        }, 
        messagesCommandsDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.destroy'
        }, 
        messagesCommandsEdit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.edit'
        }, 
        messagesCommandsExcel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.excel'
        }, 
        messagesCommandsSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.save'
        }, 
        messagesCommandsUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.update'
        }, 
        messagesNoRecords: {
            type: String,
            default: undefined,
            kComposite: 'messages.noRecords'
        }, 
        messagesExpandCollapseColumnHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.expandCollapseColumnHeader'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Messages.js